<template lang='pug'>
  v-container(fill-height)
    v-row
      v-col
        v-row.front-text(justify='center')
          h1.text-h4.blue-grey--text.text--darken-1 Reset Password
        v-row
          v-col(md='6' offset-md='3' sm='8' offset-sm='2')
            form#signUpForm(@submit.prevent='reset').mr-4.ml-4
              v-text-field(prepend-icon='lock'
                label='Password'
                v-model='password'
                min='8'
                :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                @click:append='hidePassword = !hidePassword'
                :type="hidePassword ? 'password' : 'text'"
                required)
              v-text-field(label='Confirm Password'
                :prepend-icon="(password === confirmPassword) ? 'check' : 'keyboard_arrow_right'"
                v-model='confirmPassword'
                min='8'
                :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                @click:append='hidePassword = !hidePassword'
                :type="hidePassword ? 'password' : 'text'"
                required)
              v-row(justify='end')
                v-btn(color='primary' :disabled='disableButton' type='submit') Reset Password
</template>

<script>
import {mapActions} from 'vuex';
import Notifications from '../services/notification.service';
import External from '../api/external';

export default {
  name: 'Reset',
  props: ['token'],
  methods: {
    async reset() {
      if (this.password !== this.confirmPassword) {
        return Notifications.alert('Passwords do not match');
      }
      if (this.password.length < 8) {
        return Notifications.alert('Password must be at least 8 characters long');
      }
      this.disableButton = true;
      try {
        const user = (await External.reset(this.token, this.password)).data;
        await this.setUser(user);
        this.goHome();
      } catch (e) {
        this.error(e);
      } finally {
        this.disableButton = false;
      }
      return true;
    },
    goHome() {
      Notifications.toast('Account Reset Successfully');
      return this.$router.push('/');
    },
    abort() {
      return this.$router.push('/signin');
    },
    async error(err) {
      console.error(err);
      await Notifications.alert('Invalid token. Redirecting.');
      this.abort();
    },
    ...mapActions({setUser: 'setUser'})
  },
  data() {
    return {
      disableButton: false,
      hidePassword: true,
      password: null,
      confirmPassword: null
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
